module.exports = __webpack_public_path__ + "static/img/introduce_11.42118b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_11.png
// module id = WhL8
// module chunks = 1